export const MISSING = "—";

export function showValue(value: string | number | null | undefined): string {
  return value === null || value === undefined ? MISSING : String(value);
}

// 北京时间固定为 UTC+8，不实行夏令时。
const BEIJING_OFFSET_MS = 8 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

function toUtcSeconds(ms: number): string {
  return new Date(ms).toISOString().replace(/\.\d{3}Z$/, "Z");
}

export function formatBeijingTime(timestamp: string | null | undefined): string {
  if (timestamp === null || timestamp === undefined) return MISSING;
  const ms = Date.parse(timestamp);
  if (Number.isNaN(ms)) return timestamp;
  return new Date(ms + BEIJING_OFFSET_MS).toISOString().slice(0, 19).replace("T", " ");
}

export function beijingDayRange(now: Date): { from: string; to: string } {
  const startMs =
    Math.floor((now.getTime() + BEIJING_OFFSET_MS) / DAY_MS) * DAY_MS - BEIJING_OFFSET_MS;
  return { from: toUtcSeconds(startMs), to: toUtcSeconds(startMs + DAY_MS) };
}
